import { CompetitionStageDto, type PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";
import { isDpsScheme } from "../../buyer/wizard/utils/procedure";

// Two-stage events (begrenset anbudskonkurranse) have no tilbudsfrist until the invitation —
// during stage 1 the request deadline is the phase-relevant deadline the portal shows. During
// the qualification window (requests closed, invitation pending) there is no active deadline.
export const effectiveDeadlineIso = (event: PortalSourcingEventDetailDto): string | null => {
  if (event.competitionStage === CompetitionStageDto.Qualification) return null;
  return event.bidSubmissionDeadline ?? event.requestDeadline ?? null;
};

// Phase comes from the server-derived competitionStage — never inferred from which deadline
// fields happen to be null (that inference breaks for procedures where both coexist, e.g. DPS).
export const isRequestPhase = (event: PortalSourcingEventDetailDto): boolean =>
  event.competitionStage === CompetitionStageDto.RequestsOpen;

// What the shown deadline is called. An ordning keeps admitting suppliers after the announced
// frist (FOA § 26-6), so its date is the first intake rather than the last chance to take part.
// t('Bid deadline') t('Deadline for requests to participate') t('Deadline for the first intake')
export const deadlineLabelKey = (event: PortalSourcingEventDetailDto): string =>
  !isRequestPhase(event) ? "Bid deadline"
  : isDpsScheme(event.procedureType) ? "Deadline for the first intake"
  : "Deadline for requests to participate";
